import { scopify } from '@rdss/core'
import { FunctionalComponent, h } from '@stencil/core'
import { Product } from '@rdss/client'

/**
 * Represents the product bundle items.
 */
export const BundleList: FunctionalComponent<{
    isBundleAvailable: boolean,
    article: Product,
    notice: string
}> = ({ isBundleAvailable, article, notice }) =>
    <div class="product-description">
        <div class="bundle-information"
            innerHTML={scopify(article.content?.description, ['p'], 'sc-wf-product-detail-page')}>
        </div>

        <div class="bundle-information-notice">{notice}</div>

        {isBundleAvailable &&
            <div class="wf-bundle-item-list">
                {article.stock > 0 && Object
                    .values(article.bundles)
                    .map(product => <wf-bundle-item {...{ product }}/>)
                }
            </div>
        }
    </div>
